import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.machine_implements_hourly_work_reports_page', () => {
  import('./internal/machine_implements_hourly_work_reports_page').then(({ default: Component }) => Component());
});
